<template>
  <div class="articleDetail">
    <div class="crumbs">
      <div class="container">
        <div>
          <router-link :to="navData.path" class="link">
            {{ navData.text }}
          </router-link>
          > {{ detail }}
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="container">
        <div class="article">
          <div class="title">{{ title }}</div>
          <div class="infos clearfix">
            <span style="margin-right: 15px"
              >发布时间：{{ createTime | FormatDate }}</span
            >
            <span>发布人：{{ publisher }}</span>
          </div>
          <br />
          <br />
          <!-- 项目信息  -->
          <div class="detailContent">
            <el-row :gutter="20">
              <el-form
                size="medium"
                label-width="120px"
                label-position="right"
                label-suffix="："
              >
                <el-col :span="24">
                  <div class="pre_info_title">
                    <div class="gr_list_p"></div>
                    <div class="gr_list_c">项目信息</div>
                    <hr />
                  </div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目名称">
                    <span class="content">{{ projectName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目编号">
                    <span class="content">{{ projectNumber }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目类型">
                    <span class="content">{{ projectType }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目所在地">
                    <span class="content">{{ address }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="招标人名称">
                    <span class="content">{{ tenderName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="招标内容">
<!--                    <span class="content">{{ projectContent }}</span>-->
                    <div v-html="projectContent" class="ql-editor"></div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <span class="content">{{ remark }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="招标文件" v-if="2 == type  && projectFiles.length && (2 == status || '-1' == supplierId)">
                    <p style="line-height: 25px">
                      <a
                        :href="imgBase + file.path"
                        v-for="file in projectFiles"
                        :download="file.name"
                      >{{ file.name }}
                      </a>
                    </p>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <!--公示信息-->
          <div v-if="supplierId">
            <div class="gr_list_c" >公示信息</div>
            <hr />
            <el-form
              size="medium"
              label-width="120px"
              label-position="right"
            >
              <el-form-item label="招标类型" v-if="2 == type && purchaseType != ''">
                <span class="content">{{ purchaseType }}</span>
              </el-form-item>
              <el-form-item label="报名时间" v-if="2 == type && signBeginTime != ''">
                <span class="content">{{ signBeginTime }}  至  {{signEndTime}}</span>
              </el-form-item>
              <el-form-item label="价格" v-if="4 == type">
                <div v-if="'自主投资' == projectType">
                  <span>{{ price }} &nbsp;元</span>
                </div>
                <div v-else><span> -- </span>&nbsp;元</div>
              </el-form-item>
            </el-form>
            <div v-html="article" class="ql-editor"></div>
            <div
              class="attachments"
              style="margin-top: 20px"
              v-if="cmsFiles.length"
            >
              <div style="margin-bottom: 15px">附件：</div>
              <p style="line-height: 25px">
                <a
                  :href="imgBase + file.path"
                  v-for="file in cmsFiles"
                  :download="file.name"
                >{{ file.name }}
                </a>
              </p>
            </div>
            <div
              v-if="2 == type && (0 == status || 3 == status)"
              class="button-container"
            >
              <el-button
                type="primary"
                style="width: 150px"
                :loading="loading"
                @click="signUp"
              >报名</el-button
              >
            </div>
          </div>
          <!--未登录在采购公示中也可查看公示详情-->
          <div v-if="!supplierId && 2 == type">
            <div class="gr_list_c" >公示信息</div>
            <hr />
            <el-form
              size="medium"
              label-width="120px"
              label-position="right"
            >
              <el-form-item label="招标类型" v-if="purchaseType != ''">
                <span class="content">{{ purchaseType }}</span>
              </el-form-item>
              <el-form-item label="报名时间" v-if="signBeginTime != ''">
                <span class="content">{{ signBeginTime }}  至  {{signEndTime}}</span>
              </el-form-item>
            </el-form>
            <div v-html="article" class="ql-editor"></div>
            <div
              class="attachments"
              style="margin-top: 20px"
              v-if="cmsFiles.length"
            >
              <div style="margin-bottom: 15px">附件：</div>
              <p style="line-height: 25px">
                <a
                  :href="imgBase + file.path"
                  v-for="file in cmsFiles"
                  :download="file.name"
                >{{ file.name }}
                </a>
              </p>
            </div>
            <div class="button-container">
              <el-button
                type="primary"
                style="width: 150px"
                :loading="loading"
                @click="signUpNoLogin"
              >报名</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      center
      width="1000px"
      top="15vh"
    >
      <div class="dialog-content lg">
        <el-form
          ref="form"
          label-width="140px"
          label-suffix="："
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="资质文件" prop="enterpriseName">
<!--                <el-upload :action="'cxzcz/ds'">-->
<!--                  <el-button size="small" type="primary">选择文件</el-button>-->
<!--                </el-upload>-->
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :on-remove="handleRemove"
                  :file-list="form.tenderFiles"
                  :auto-upload="false"
                  :show-file-list="true"
                  :on-change="changeFile"
                  :limit="1"
                  :on-exceed="exceed"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="">
            <span class="red-text">
              *资料真实性请务必如实填写，否则报名无效！！！*</span
            >
              </el-form-item>
            </el-col>
          </el-row>
          <div class="button-container" style="margin: 30px 0">
            <el-checkbox class="protocol" v-model="checked"
            >我已仔细阅读并接受
              <a href="javascript:void(0);" @click="checkProtocol"
              >报名承诺函</a
              ></el-checkbox
            >
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="signUpSubmit">提 交</el-button>
        </span>
    </el-dialog>
    <el-dialog
      :visible.sync="protocolDiaView"
      :modal="false"
      width="1000px"
      center
    >
      <template slot="title"><div style="font-size: 22px">报名承诺函</div></template>
      <div v-html="this.signUpProtocol"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmProtocol()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const base = process.env.VUE_APP_IMG_API
import { getNoticeDetail, getNoticeDetailLogout, signUp } from "@/api";
import { formatDate } from '@/utils';
import "@/assets/css/quill-better-table.css";
import "@/assets/css/quill.snow.css";
export default {

  data () {
    return {
      imgBase: base,
      checked: false,
      supplierId: "",
      loading: false,
      projectId: "",
      projectName: "",
      address: "",
      tenderName: "",
      projectContent: "",
      remark: "",
      title: "",
      type: 0,
      status: "",
      createTime: "",
      publisher: "",
      article: "",
      purchaseType: "",
      detail: "公示详情",
      enterpriseName: "",
      enterprisePhone: "",
      cmsFiles: [],
      projectFiles: [],
      navData: this.utils.navMap[this.$route.params.parent],
      projectType: "",
      signBeginTime: "",
      signEndTime: "",
      projectNumber: "",
      originType: '', // 跳转来源
      supplierStatus: "",
      dialog:{
        title: "报名",
        visible: false,
      },
      signUpProtocol: '',
      form:{
        tenderFiles: [],
      },
      protocolDiaView: false,
    };
  },
  created () {
    this.originType = this.$route.query.originType;
    console.log("this.originType = " + this.originType);
    this.supplierId = localStorage.getItem("supplierId");
  },
  async mounted () {
    if(localStorage.getItem("supplierId")){
      let data = await getNoticeDetail(this.$route.params.id, localStorage.getItem("supplierId"));
      this.noticeId = data.data.data.noticeId;
      this.projectId = data.data.data.projectId;
      this.projectName = data.data.data.projectName;
      this.address = data.data.data.address;
      this.tenderName = data.data.data.tenderName;
      this.projectContent = data.data.data.projectContent;
      this.remark = data.data.data.remark;
      this.article = data.data.data.content;
      this.title = data.data.data.title;
      this.type = data.data.data.type;
      this.status = data.data.data.status; // 报名审核状态
      this.publisher = data.data.data.publisher;
      this.price = data.data.data.price;
      this.createTime = data.data.data.createTime;
      this.cmsFiles = data.data.data.purchaseFiles ? data.data.data.purchaseFiles : [];
      this.projectType = data.data.data.projectType;
      this.projectNumber = data.data.data.projectNumber;
      this.purchaseType = data.data.data.purchaseType;
      this.enterpriseName = data.data.data.enterpriseName;
      this.enterprisePhone = data.data.data.enterprisePhone;
      this.signBeginTime = data.data.data.signBeginTime ? formatDate(data.data.data.signBeginTime) : '';
      this.signEndTime = data.data.data.signEndTime? formatDate(data.data.data.signEndTime) : '';
      this.projectFiles = data.data.data.projectFiles ? data.data.data.projectFiles : []; // 项目附件
      this.supplierStatus = data.data.data.supplierStatus; // 供应商审核状态
      this.signUpProtocol = '<p><span style="font-size: 20px;">致: 安康大数据运营有限公司</span></p><p><span style="font-size: 20px;"><br/></span></p><p><span style="font-size: 20px;"><br/></span></p><p><span style="white-space-collapse: preserve;">\t</span><span style="font-size: 18px;"> 我单位经认真对照贵公司 '+ this.projectName +'项目的报名资质要求，现已充分理解其全部内容，自愿参与该项目的报名。</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我单位承诺将按要求向贵公司提供真实、准确的报名材料且近 3 年内没有受各级管理部门的处分或处罚(含其授权服务的子公司、分公司等 )，如不符合以上承诺，我公司同意被取消报名、投标、中标等资格，所产生的一切后果由我公司自行承担。</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;">特别提醒:</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="white-space-collapse: preserve;">\t </span><span style="font-size: 18px;">\t1、供应商在报名、投标过程、质疑、合同签订、供货履约等环节弄虚作假的，作违约处理</span><span style="font-size: 18px;">。</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;"><span style="font-size: 18px; white-space-collapse: preserve;">\t</span>2、报名后各供应商持续关注安康大数据运营有限公司官网可能发生的后续信息变化，如因没有及时获悉相关变化而导致的一系列后果由供应商自行负责。</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;"><span style="font-size: 18px; white-space-collapse: preserve;">\t</span>3、请各供应商认真阅读采购文件全部内容，严格遵守文件中提出的相关要求，如有疑问请及时联系采购人。</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;"><span style="font-size: 18px; white-space-collapse: preserve;">\t</span>4、招标公告发出后，潜在供应商根据招标公告内容，在集中报名或领取招标文件前，可提出询问或质疑;集中报名后，供应商未报名或未领取招标文件的，不能提出质疑。</span></p><p><br/></p>';
    }else{
      // 未登录, 只能看到部分信息
      let data = await getNoticeDetailLogout(this.$route.params.id);
      this.noticeId = data.data.data.noticeId;
      this.projectId = data.data.data.projectId;
      this.projectName = data.data.data.projectName;
      this.address = data.data.data.address;
      this.tenderName = data.data.data.tenderName;
      this.projectContent = data.data.data.projectContent;
      this.remark = data.data.data.remark;
      this.article = data.data.data.content;
      this.title = data.data.data.title;
      this.type = data.data.data.type;
      this.publisher = data.data.data.publisher;
      this.createTime = data.data.data.createTime;
      this.projectType = data.data.data.projectType;
      this.projectNumber = data.data.data.projectNumber;
      this.status = data.data.data.status; // 报名审核状态
      this.purchaseType = data.data.data.purchaseType;
      this.signBeginTime = data.data.data.signBeginTime ? formatDate(data.data.data.signBeginTime) : '';
      this.signEndTime = data.data.data.signEndTime? formatDate(data.data.data.signEndTime) : '';
      this.cmsFiles = data.data.data.purchaseFiles ? data.data.data.purchaseFiles : [];
    }
    // 存入搜索标识
    sessionStorage.setItem("searchFlag", true);
  },
  methods: {
    signUp () {
      console.log("================");
      if (!this.supplierStatus || 0 == this.supplierStatus || 2 == this.supplierStatus) {
        this.$message({ type: "error", message: "您的企业信息正在审核中或审核未通过， 暂无法报名！！！" });
        return;
      }
      this.dialog.visible = true;
    },
    signUpNoLogin(){
      if(!this.supplierId){
        this.$message({type: 'warning', message: '请先注册为供应商'});
        setTimeout(() =>{
          this.$router.push("/register")
        }, 1500);
      }
    },
    closeDialog(){
      this.dialog.visible = false;
      this.checked = false;
      this.form.tenderFiles = [];
    },
    // 报名提交
    signUpSubmit(){
      console.log("报名提交  start>>>");
      if(!this.form.tenderFiles || this.form.tenderFiles.length == 0){
        this.$message({ type: "warning", message: "请上传资质文件" });
        return;
      }
      if (!this.checked) {
        this.$message({ type: "warning", message: "请勾选投标承诺函" });
        return;
      }
      if(this.signBeginTime == '' || this.signEndTime == ''){
        this.$message({ type: "error", message: "未在报名时间段内， 无法报名！" });
        return;
      }

      var date = new Date();
      if(date.getTime() <  new Date(this.signBeginTime) || date.getTime() > new Date(this.signEndTime)){
        this.$message({ type: "error", message: "未在报名时间段内， 无法报名！" });
        return;
      }
      var that = this;
      this.$confirm("确认提交吗？", "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function () {
        that.form.supplierId = localStorage.getItem("supplierId");
        that.form.projectId = that.projectId;
        let formData = new FormData();
        const HEADERS = {
          "Content-Type": "multipart/form-data"
        };
        for (let key in that.form) {
          if (key === "tenderFiles") {
            if (that.form["tenderFiles"].length > 0) {
              that.form["tenderFiles"].forEach(item => {
                formData.append("tenderFiles", item);
              });
            }
          } else {
            if (
              that.form[key] !== null &&
              that.form[key] != "" &&
              that.form[key] != {}
            ) {
              formData.append(key, that.form[key]);
            }
          }
        }
        signUp(formData,  HEADERS).then(res => {
          if (res.data.success) {
            that.loading = false;
            console.log("6666666666666666666");
            // this.$store.commit('LOGIN_IN', res.data.token);
            that.$router.push('/purchaseManage/tender');
          }
        }).catch(() => {
          that.loading = false;
        });
      });
    },
    checkProtocol () {
      this.protocolDiaView = true;
    },
    confirmProtocol () {
      this.protocolDiaView = false;
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.form.tenderFiles = fileList;
    },
    changeFile (file) {
      console.log(file);
      this.form.tenderFiles.push(file.raw);
      // this.form.coverImage = file.raw;
    },
    exceed(file, fileList){
      this.$message({type: "error", message: '资质文件附件只能上传一个！'});
    },
  }
}
</script>
<style lang="scss" >
.ql-editor {
  img {
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.crumbs {
  height: 50px;
  line-height: 50px;
  color: #333;
  font-size: 14px;
  border-bottom: solid 1px #d6d6d6;
  margin-bottom: 30px;
}
.crumbs .link {
  color: #8d8d8d;
}
.title {
  text-align: center;
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 20px;
  line-height: 30px;
}
.infos {
  color: #888;
  font-size: 15px;
  border-bottom: 1px solid #eee;
  line-height: 35px;
}
.articleDetail {
  padding-bottom: 80px;
}
.button-container {
  text-align: center;
  margin-top: 50px;
}
.gr_list_c {
  font-weight: 600;
  font-size: 20px;
  /*text-align: center;*/
  margin: 5px 0 20px 0;
}
.red-text {
  color: red;
}
</style>
